// import { AppDispatch, AppState, /* AppState*/ } from '..'
// import { BASES_TO_TRACK_LIQUIDITY_FOR, FACTORY_ADDRESS } from '../../constants'
// import { /* computePairAddress, JSBI, Pair, Percent,*/ Token } from '@emberswap/emberswap-sdk2'
import { Token } from '@emberswap/emberswap-sdk2/dist/entities'
import ChainId from '@emberswap/emberswap-sdk2/dist/enums/ChainId'
import stringify from 'fast-json-stable-stringify'
// import { useAppDispatch, useAppSelector } from '..'
import { useCallback, useMemo } from 'react'
import { /* shallowEqual,*/ useDispatch, useSelector } from 'react-redux'

import {
  createFailedToast,
  createInfoToast,
  createInlineToast,
  createSuccessToast,
  createToast,
  NotificationData,
} from '../../components/Toast'
import {
  addCustomToken as _addCustomToken,
  addCustomTokens as _addCustomTokens,
  // SerializedPair,
  // SerializedToken,
  // addSerializedPair,
  // addSerializedToken,
  addPinnedToken as _addPinnedToken,
  addUserPath,
  clearNotifications as _clearNotifications,
  // removeSerializedToken,
  // toggleURLWarning,
  // updateUserArcherETHTip,
  // updateUserArcherGasEstimate,
  // updateUserArcherGasPrice,
  // updateUserArcherTipManualOverride,
  // updateUserArcherUseRelay,
  // updateUserDarkMode,
  // updateUserFarmFilter,
  // updateUserVaultFilter,
  createNotification as _createNotification,
  removeCustomToken as _removeCustomToken,
  removePath as _removePath,
  removePinnedToken as _removePinnedToken,
  resetPath as _resetPath,
  updateUserDeadline,
  updateUserDeadlineType,
  updateUserExpertMode,
  updateUserPathType as _updateUserPathType,
  // updateUserSingleHopOnly,
  updateUserSlippageTolerance,
  updateUserSlippageToleranceType,
} from './actions'
// import { useAllTokens } from '../../hooks/Token/useAllTokens'
// import useActiveWeb3React from '../../wagmi/hooks/useActiveWeb3React'
// import flatMap from 'lodash/flatMap'
import { TokenAsObject, UserState, /* UserState,*/ WithUserState } from './reducer'

type UseCustomTokensReturn = [
  Record<string, Token>,
  {
    addCustomToken(payload: TokenAsObject): void
    addCustomTokens(payload: TokenAsObject[]): void
    removeCustomToken(payload: Pick<TokenAsObject, 'address' | 'chainId'>): void
  }
]
// type UseCustomTokensReturn = Record<string, Token>

type UseCustomTokens = (chainId?: number) => UseCustomTokensReturn

export const useCustomTokens: UseCustomTokens = (chainId?: number) => {
  const customTokens = useSelector((state: WithUserState) => state.user?.customTokens)
  const dispatch = useDispatch()

  const addCustomToken = useCallback(
    ({ symbol, address, chainId, name, decimals }: TokenAsObject) => {
      dispatch(_addCustomToken({ symbol, address, chainId, name, decimals }))
    },
    [dispatch]
  )

  const addCustomTokens = useCallback(
    (tokens: TokenAsObject[]) => {
      dispatch(_addCustomTokens(tokens))
    },
    [dispatch]
  )

  const removeCustomToken = useCallback(
    ({ address, chainId }: Pick<TokenAsObject, 'address' | 'chainId'>) => {
      dispatch(_removeCustomToken({ address, chainId }))
    },
    [dispatch]
  )

  const tokens = useMemo(() => {
    if (!chainId || !customTokens || !customTokens[chainId]) return {}
    return Object.entries(customTokens[chainId]).reduce<Record<string, Token>>(
      (acc, [k, { chainId, decimals, name, symbol, address }]) => {
        acc[k] = new Token({ chainId, decimals, name, symbol, address })
        return acc
      },
      {}
    )
  }, [chainId, customTokens])

  return [tokens, { addCustomToken, removeCustomToken, addCustomTokens }]
}

type UseSettingsReturn = [
  Omit<UserState, 'settings'>,
  {
    updateSlippageTolerance(slippageTolerance: string): void
    updateSlippageToleranceType(slippageToleranceType: 'auto' | 'custom'): void
    updateExpertMode(expertMode: boolean): void
    updateTransactionDeadline(deadline: number): void
    updateTransactionDeadlineType(userDeadlineType: 'auto' | 'custom'): void
    updateUserPathType(userPathType: 'auto' | 'custom'): void
    addPath(payload: TokenAsObject): void
    removePath(payload: Pick<TokenAsObject, 'address' | 'chainId'>): void
    resetPath(chainId: ChainId): void
    addPinnedToken(payload: string): void
    removePinnedToken(payload: string): void
  }
]
type UseSettings = (chainId?: number) => UseSettingsReturn

export const useSettings: UseSettings = (chainId?: number) => {
  const { ...settings } = useSelector((state: WithUserState) => state.user)
  const dispatch = useDispatch()

  const updateExpertMode = useCallback(
    (expertMode: boolean) => {
      dispatch(updateUserExpertMode({ userExpertMode: expertMode }))
    },
    [dispatch]
  )

  const addPath = useCallback(
    ({ symbol, address, chainId, name, decimals }: TokenAsObject) => {
      dispatch(addUserPath({ symbol, address, chainId, name, decimals }))
    },
    [dispatch]
  )

  const resetPath = useCallback(
    (chainId: ChainId) => {
      dispatch(_resetPath({ chainId }))
    },
    [dispatch]
  )

  const removePath = useCallback(
    ({ address, chainId }: Pick<TokenAsObject, 'address' | 'chainId'>) => {
      dispatch(_removePath({ address, chainId }))
    },
    [dispatch]
  )

  const updateUserPathType = useCallback(
    (userPathType: 'auto' | 'custom') => {
      dispatch(_updateUserPathType({ userPathType }))
    },
    [dispatch]
  )

  const addPinnedToken = useCallback(
    (currencyId: string) => {
      dispatch(_addPinnedToken({ currencyId }))
    },
    [dispatch]
  )
  const removePinnedToken = useCallback(
    (currencyId: string) => {
      dispatch(_removePinnedToken({ currencyId }))
    },
    [dispatch]
  )

  const updateSlippageTolerance = useCallback(
    (slippageTolerance: string) => {
      dispatch(updateUserSlippageTolerance({ userSlippageTolerance: slippageTolerance }))
    },
    [dispatch]
  )

  const updateSlippageToleranceType = useCallback(
    (slippageToleranceType: 'auto' | 'custom') => {
      dispatch(updateUserSlippageToleranceType({ slippageToleranceType }))
    },
    [dispatch]
  )

  const updateTransactionDeadlineType = useCallback(
    (userDeadlineType: 'auto' | 'custom') => {
      dispatch(updateUserDeadlineType({ userDeadlineType }))
    },
    [dispatch]
  )

  const updateTransactionDeadline = useCallback(
    (transactionDeadline: number) => {
      dispatch(updateUserDeadline({ userDeadline: transactionDeadline }))
    },
    [dispatch]
  )

  return [
    settings,
    {
      updateExpertMode,
      updateSlippageTolerance,
      updateSlippageToleranceType,
      updateTransactionDeadline,
      updateTransactionDeadlineType,
      updateUserPathType,
      addPath,
      removePath,
      resetPath,
      addPinnedToken,
      removePinnedToken
    },
  ]
}
type UseNotificationsReturn = [
  Record<number, string[]>,
  {
    createNotification(notification: NotificationData): void
    createInlineNotification(notification: NotificationData): void
    createSuccessNotification(notification: Omit<NotificationData, 'promise'>): void
    createFailedNotification(notification: Omit<NotificationData, 'promise'>): void
    createInfoNotification(notification: Omit<NotificationData, 'promise'>): void
    clearNotifications(): void
  }
]

type UseNotifications = (account: string | undefined) => UseNotificationsReturn

export const useNotifications: UseNotifications = (account) => {
  const dispatch = useDispatch()
  const notifications = useSelector((state: WithUserState) =>
    account ? state.user.notifications?.[account] : {}
  )

  const createNotification = useCallback(
    ({ promise, ...rest }: NotificationData) => {
      const { groupTimestamp } = rest
      createToast({ ...rest, promise })
      dispatch(
        _createNotification({
          account: account ? account : '',
          notification: stringify(rest),
          timestamp: groupTimestamp,
        })
      )
    },
    [account, dispatch]
  )

  const createSuccessNotification = useCallback(
    (rest: NotificationData) => {
      const { groupTimestamp } = rest
      createSuccessToast(rest)
      dispatch(
        _createNotification({
          account: account ? account : '',
          notification: stringify(rest),
          timestamp: groupTimestamp,
        })
      )
    },
    [account, dispatch]
  )

  const createFailedNotification = useCallback(
    (rest: NotificationData) => {
      const { groupTimestamp } = rest
      createFailedToast(rest)
      dispatch(
        _createNotification({
          account: account ? account : '',
          notification: stringify(rest),
          timestamp: groupTimestamp,
        })
      )
    },
    [account, dispatch]
  )

  const createInfoNotification = useCallback(
    (rest: NotificationData) => {
      const { groupTimestamp } = rest
      createInfoToast(rest)
      dispatch(
        _createNotification({
          account: account ? account : '',
          notification: stringify(rest),
          timestamp: groupTimestamp,
        })
      )
    },
    [account, dispatch]
  )

  const createInlineNotification = useCallback(
    ({ promise, ...rest }: NotificationData) => {
      const { groupTimestamp } = rest
      createInlineToast({ ...rest, promise })
      dispatch(
        _createNotification({
          account: account ? account : '',
          notification: stringify(rest),
          timestamp: groupTimestamp,
        })
      )
    },
    [account, dispatch]
  )

  const clearNotifications = useCallback(() => {
    dispatch(_clearNotifications({ account: account ? account : '' }))
  }, [account, dispatch])

  return [
    notifications || {},
    {
      createNotification,
      clearNotifications,
      createInlineNotification,
      createSuccessNotification,
      createFailedNotification,
      createInfoNotification,
    },
  ]
}
/**
 *
 */
// type AddCustomTokenReturn = { addCustomToken(payload: TokenAsObject): void }
// type AddCustomToken = () => AddCustomTokenReturn

// export const useCustomToken: AddCustomToken = () => {
//   const dispatch = useDispatch()
//   const addCustomToken = useCallback(
//     ({ symbol, address, chainId, name, decimals }: TokenAsObject) => {
//       dispatch(addcustomtoken({ symbol, address, chainId, name, decimals }))
//     },
//     [dispatch]
//   )
//   return { addCustomToken }
// }
// /**
//  *
//   */
//  export function useAddCustomTokens(tokens: TokenAsObject[]) {
//    const dispatch = useAppDispatch()
//    return useCallback(() => {
//      dispatch(addcustomtokens(tokens))
//    }, [tokens, dispatch])
//  }
// /**
//  *
//  */
// export function useRemoveCustomToken({ address, chainId }: Pick<TokenAsObject, 'address' | 'chainId'>) {
//   const dispatch = useAppDispatch()
//   return useCallback(() => {
//     dispatch(removecustomtoken({ address, chainId }))
//   }, [dispatch, address, chainId])
// }
//
// /**
//  * @param param0
//  * @returns
//  */
// export const useCustomTokens:UseCustomTokens = (chainId?: number)  => {
//   const customTokens = useAppSelector((state: WithUserState) => state.user?.customTokens)
//   const tokens = useMemo(() => {
//     if (!chainId || !customTokens[chainId]) return {}
//     return Object.entries(customTokens[chainId]).reduce<Record<string, Token>>(
//       (acc, [k, { chainId, decimals, name, symbol, address }]) => {
//         acc[k] = new Token({ chainId, decimals, name, symbol, address })
//         return acc
//       },
//       {}
//     )
//   }, [chainId, customTokens])
//
//   return tokens
// }
/**
 *
 */
// function serializeToken(token: Token): SerializedToken {
//   return {
//     chainId: token.chainId,
//     address: token.address,
//     decimals: token.decimals,
//     symbol: token.symbol,
//     name: token.name,
//   }
// }
/**
 *
 */
// function deserializeToken(serializedToken: SerializedToken): Token {
//   return new Token({
//     chainId: serializedToken.chainId,
//     address: serializedToken.address,
//     decimals: serializedToken.decimals,
//     symbol: serializedToken.symbol,
//     name: serializedToken.name
//   })
// }

// export function getFarmFilter(): string {
//   return useAppSelector((state) => state.user.userFarmFilter)
// }
//
// export function getVaultFilter(): string {
//   return useAppSelector((state) => state.user.userVaultFilter)
// }

// export function useUpdateFarmFilter(): (filter: string) => void {
//   // const dispatch = useAppDispatch()
//   // dispatch(updateUserFarmFilter({ userFarmFilter: filter }))
//   const dispatch = useDispatch<AppDispatch>()
//   return useCallback(
//     (filter: string) => {
//       dispatch(updateUserFarmFilter({ userFarmFilter: filter }))
//     },
//     [dispatch]
//   )
// }

// export function useUpdateVaultFilter(): (filter: string) => void {
//   // const dispatch = useAppDispatch()
//   // dispatch(updateUserVaultFilter({ userVaultFilter: filter }))
//   const dispatch = useDispatch<AppDispatch>()
//   return useCallback(
//     (filter: string) => {
//       dispatch(updateUserVaultFilter({ userVaultFilter: filter }))
//     },
//     [dispatch]
//   )
// }
//
// export function useIsExpertMode(): boolean {
//   return useAppSelector((state) => state.user.userExpertMode)
// }
//
// export function useExpertModeManager(): [boolean, () => void] {
//   const dispatch = useAppDispatch()
//   const expertMode = useIsExpertMode()
//
//   const toggleSetExpertMode = useCallback(() => {
//     dispatch(updateUserExpertMode({ userExpertMode: !expertMode }))
//   }, [expertMode, dispatch])
//
//   return [expertMode == true ? true : false, toggleSetExpertMode]
// }
//
// export function useUserSingleHopOnly(): [boolean, (newSingleHopOnly: boolean) => void] {
//   const dispatch = useAppDispatch()
//
//   const singleHopOnly = useAppSelector((state) => state.user.userSingleHopOnly)
//
//   const setSingleHopOnly = useCallback(
//     (newSingleHopOnly: boolean) => {
//       ReactGA.event({
//         category: 'Routing',
//         action: newSingleHopOnly ? 'enable single hop' : 'disable single hop',
//       })
//       dispatch(updateUserSingleHopOnly({ userSingleHopOnly: newSingleHopOnly }))
//     },
//     [dispatch]
//   )
//
//   return [singleHopOnly, setSingleHopOnly]
// }
//
// export function useSetUserSlippageTolerance(): (slippageTolerance: Percent | 'auto') => void {
//   const dispatch = useAppDispatch()
//
//   return useCallback(
//     (userSlippageTolerance: Percent | 'auto') => {
//       let value: 'auto' | number
//       try {
//         value =
//           userSlippageTolerance === 'auto' ? 'auto' : JSBI.toNumber(userSlippageTolerance.multiply(10_000).quotient)
//       } catch (error) {
//         value = 'auto'
//       }
//       dispatch(
//         updateUserSlippageTolerance({
//           userSlippageTolerance: value,
//         })
//       )
//     },
//     [dispatch]
//   )
// }
//
// /**
//  * Return the user's slippage tolerance, from the redux store, and a function to update the slippage tolerance
//  */
// export function useUserSlippageTolerance(): Percent | 'auto' {
//   const userSlippageTolerance = useAppSelector((state) => {
//     return state.user.userSlippageTolerance
//   })
//
//   return useMemo(
//     () => (userSlippageTolerance === 'auto' ? 'auto' : new Percent(userSlippageTolerance, 10_000)),
//     [userSlippageTolerance]
//   )
// }
//
// export function useUserTransactionTTL(): [number, (slippage: number) => void] {
//   const dispatch = useDispatch<AppDispatch>()
//   const userDeadline = useSelector<AppState, AppState['user']['userDeadline']>((state) => {
//     return state.user.userDeadline
//   })
//
//   const setUserDeadline = useCallback(
//     (userDeadline: number) => {
//       dispatch(updateUserDeadline({ userDeadline }))
//     },
//     [dispatch]
//   )
//
//   return [userDeadline, setUserDeadline]
// }

/**
 *
 */
// export function useAddUserToken(): (token: Token) => void {
//   const dispatch = useDispatch<AppDispatch>()
//   return useCallback(
//     (token: Token) => {
//       dispatch(addSerializedToken({ serializedToken: serializeToken(token) }))
//     },
//     [dispatch]
//   )
// }
//
// /**
//  * @returns
//  */
// export function useRemoveUserAddedToken(): (chainId: number, address: string) => void {
//   const dispatch = useAppDispatch()
//   return useCallback(
//     (chainId: number, address: string) => {
//       dispatch(removeSerializedToken({ chainId, address }))
//     },
//     [dispatch]
//   )
// }
//
// /**
//  *
//  * @returns
//  */
// export function useUserAddedTokens(): Token[] {
//   const { chainId } = useActiveWeb3React()
//   const serializedTokensMap = useAppSelector(({ user: { tokens } }) => tokens as Token[])
//
//   return useMemo(() => {
//     if (!chainId) return []
//     return Object.values(serializedTokensMap?.[chainId] ?? {}).map(deserializeToken)
//   }, [serializedTokensMap, chainId])
// }

/**
 *
 * @param pair
 * @returns
 */
// function serializePair(pair: Pair): SerializedPair {
//   return {
//     token0: serializeToken(pair.token0),
//     token1: serializeToken(pair.token1),
//   }
// }

/**
 *
 */
// export function usePairAdder(): (pair: Pair) => void {
//   const dispatch = useAppDispatch()
//
//   return useCallback(
//     (pair: Pair) => {
//       dispatch(addSerializedPair({ serializedPair: serializePair(pair) }))
//     },
//     [dispatch]
//   )
// }

// /**
//  *
//  * @returns
//  */
// export function useURLWarningVisible(): boolean {
//   return useAppSelector((state: AppState) => state.user.URLWarningVisible)
// }
//
// export function useURLWarningToggle(): () => void {
//   const dispatch = useAppDispatch()
//   return useCallback(() => dispatch(toggleURLWarning()), [dispatch])
// }

/**
 * Given two tokens return the liquidity token that represents its liquidity shares
 * @param tokenA one of the two tokens
 * @param tokenB the other token
 */
// export function toV2LiquidityToken([tokenA, tokenB]: [Token, Token]): Token {
//   return tokenA && tokenB && tokenA.chainId === tokenB.chainId && FACTORY_ADDRESS[tokenA.chainId]
//     ? new Token(
//         tokenA.chainId,
//         computePairAddress({ factoryAddress: FACTORY_ADDRESS[tokenA.chainId], tokenA, tokenB }),
//         18,
//         'UNI-V2',
//         'Uniswap V2'
//       )
//     : undefined
// }

/**
 * Returns all the pairs of tokens that are tracked by the user for the current chain ID.
 */
// export function useTrackedTokenPairs(): [Token, Token][] {
//   const { chainId } = useActiveWeb3React()
//   const tokens = useAllTokens()
//
//   // pairs for every token against every base
//   const generatedPairs: [Token, Token][] = useMemo(
//     () =>
//       chainId
//         ? flatMap(Object.keys(tokens), (tokenAddress) => {
//             const token = tokens[tokenAddress]
//             // for each token on the current chain,
//             return (
//               // loop though all bases on the current chain
//               (BASES_TO_TRACK_LIQUIDITY_FOR[chainId] ?? [])
//                 // to construct pairs of the given token with each base
//                 .map((base) => {
//                   if (base.address === token.address) {
//                     return null
//                   } else {
//                     return [base, token]
//                   }
//                 })
//                 .filter((p): p is [Token, Token] => p !== null)
//             )
//           })
//         : [],
//     [tokens, chainId]
//   )
//
//   // pairs saved by users
//   const savedSerializedPairs = useAppSelector(({ user: { pairs } }) => pairs)
//
//   const userPairs: [Token, Token][] = useMemo(() => {
//     if (!chainId || !savedSerializedPairs) return []
//     const forChain = savedSerializedPairs[chainId]
//     if (!forChain) return []
//
//     return Object.keys(forChain).map((pairId) => {
//       return [deserializeToken(forChain[pairId].token0), deserializeToken(forChain[pairId].token1)]
//     })
//   }, [savedSerializedPairs, chainId])
//
//   const combinedList = useMemo(() => userPairs.concat(generatedPairs), [generatedPairs, userPairs])
//
//   return useMemo(() => {
//     // dedupes pairs of tokens in the combined list
//     const keyed = combinedList.reduce<{ [key: string]: [Token, Token] }>((memo, [tokenA, tokenB]) => {
//       const sorted = tokenA.sortsBefore(tokenB)
//       const key = sorted ? `${tokenA.address}:${tokenB.address}` : `${tokenB.address}:${tokenA.address}`
//       if (memo[key]) return memo
//       memo[key] = sorted ? [tokenA, tokenB] : [tokenB, tokenA]
//       return memo
//     }, {})
//
//     return Object.keys(keyed).map((key) => keyed[key])
//   }, [combinedList])
// }
//
// export function useUserArcherUseRelay(): [boolean, (newUseRelay: boolean) => void] {
//   const dispatch = useAppDispatch()
//
//   const useRelay = useSelector<AppState, AppState['user']['userArcherUseRelay']>(
//     (state) => state.user.userArcherUseRelay
//   )
//
//   const setUseRelay = useCallback(
//     (newUseRelay: boolean) => {
//       dispatch(updateUserArcherUseRelay({ userArcherUseRelay: newUseRelay }))
//     },
//     [dispatch]
//   )
//
//   return [useRelay, setUseRelay]
// }
//
// export function useUserArcherGasPrice(): [string, (newGasPrice: string) => void] {
//   const dispatch = useAppDispatch()
//   const userGasPrice = useSelector<AppState, AppState['user']['userArcherGasPrice']>((state) => {
//     return state.user.userArcherGasPrice
//   })
//
//   const setUserGasPrice = useCallback(
//     (newGasPrice: string) => {
//       dispatch(updateUserArcherGasPrice({ userArcherGasPrice: newGasPrice }))
//     },
//     [dispatch]
//   )
//
//   return [userGasPrice, setUserGasPrice]
// }
//
// export function useUserArcherETHTip(): [string, (newETHTip: string) => void] {
//   const dispatch = useAppDispatch()
//   const userETHTip = useSelector<AppState, AppState['user']['userArcherETHTip']>((state) => {
//     return state.user.userArcherETHTip
//   })
//
//   const setUserETHTip = useCallback(
//     (newETHTip: string) => {
//       dispatch(updateUserArcherETHTip({ userArcherETHTip: newETHTip }))
//     },
//     [dispatch]
//   )
//
//   return [userETHTip, setUserETHTip]
// }
//
// export function useUserArcherGasEstimate(): [string, (newGasEstimate: string) => void] {
//   const dispatch = useAppDispatch()
//   const userGasEstimate = useSelector<AppState, AppState['user']['userArcherGasEstimate']>((state) => {
//     return state.user.userArcherGasEstimate
//   })
//
//   const setUserGasEstimate = useCallback(
//     (newGasEstimate: string) => {
//       dispatch(
//         updateUserArcherGasEstimate({
//           userArcherGasEstimate: newGasEstimate,
//         })
//       )
//     },
//     [dispatch]
//   )
//
//   return [userGasEstimate, setUserGasEstimate]
// }
//
// export function useUserArcherTipManualOverride(): [boolean, (newManualOverride: boolean) => void] {
//   const dispatch = useAppDispatch()
//   const userTipManualOverride = useSelector<AppState, AppState['user']['userArcherTipManualOverride']>((state) => {
//     return state.user.userArcherTipManualOverride
//   })
//
//   const setUserTipManualOverride = useCallback(
//     (newManualOverride: boolean) => {
//       dispatch(
//         updateUserArcherTipManualOverride({
//           userArcherTipManualOverride: newManualOverride,
//         })
//       )
//     },
//     [dispatch]
//   )
//
//   return [userTipManualOverride, setUserTipManualOverride]
// }
//
// /**
//  * Same as above but replaces the auto with a default value
//  * @param defaultSlippageTolerance the default value to replace auto with
//  */
// export function useUserSlippageToleranceWithDefault(defaultSlippageTolerance: Percent): Percent {
//   const allowedSlippage = useUserSlippageTolerance()
//   return useMemo(
//     () => (allowedSlippage === 'auto' ? defaultSlippageTolerance : allowedSlippage),
//     [allowedSlippage, defaultSlippageTolerance]
//   )
// }
//
